import { render, staticRenderFns } from "./AccountBalancesOverviewWidget.vue?vue&type=template&id=5a2931b0&scoped=true&"
import script from "./AccountBalancesOverviewWidget.vue?vue&type=script&lang=js&"
export * from "./AccountBalancesOverviewWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2931b0",
  null
  
)

export default component.exports